import { connect } from 'react-redux';
import { Map as ImmutableMap } from 'immutable';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'them... Remove this comment to see the full error message
import WebFontLoader from 'theme-previewer-lib/components/WebFontLoader';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'them... Remove this comment to see the full error message
import { getGoogleFontsMap } from 'theme-previewer-lib/utils/fonts';
const mapStateToProps = ({
  theme = {},
  // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
  templateSettings = new ImmutableMap()
}) => {
  return {
    googleFontsMap: getGoogleFontsMap(theme.fields || [], templateSettings.get('themeSettings'))
  };
};
export default connect(mapStateToProps)(WebFontLoader);